"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _lodash = _interopRequireDefault(require("lodash"));

var _default = _interopRequireDefault(require("./models/default"));

var _entityModel = _interopRequireDefault(require("./models/entity-model"));

var _valueListModel = _interopRequireDefault(require("./models/value-list-model"));

var _excluded = ["entities", "valueLists"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Generator class that allows to create new redux models from
 * a global set of configs and offers several blueprints for common
 * use cases (API entities, API value lists)
 * @param  {string} type
 * @param  {Object} config
 * @constructor
 */
var ReduxModelGenerator = /*#__PURE__*/function () {
  function ReduxModelGenerator(modelName, config) {
    (0, _classCallCheck2.default)(this, ReduxModelGenerator);
    this.modelName = modelName; // NOTE: the default configs are specified for each
    //  model type individually

    this.config = _lodash.default.merge({
      entities: {},
      valueLists: {}
    }, config);
  } // Some statics


  (0, _createClass2.default)(ReduxModelGenerator, [{
    key: "createModel",
    value:
    /**
     * Creates custom model
     * @param  {Object} options
     * @return {Model}
     */
    function createModel(options) {
      var _this$config = this.config,
          entities = _this$config.entities,
          valueLists = _this$config.valueLists,
          config = (0, _objectWithoutProperties2.default)(_this$config, _excluded);
      return new _default.default(_objectSpread({
        modelName: this.modelName,
        config: config
      }, options));
    }
    /**
     * Creates entity model
     * @param  {Object} options
     * @return {EntityModel}
     */

  }, {
    key: "createEntityModel",
    value: function createEntityModel(options) {
      return new _entityModel.default(_objectSpread({
        modelName: this.modelName,
        config: this.config.entities
      }, options));
    }
    /**
     * Creates value list model
     * @param  {Object} options
     * @return {ValueListModel}
     */

  }, {
    key: "createValueListModel",
    value: function createValueListModel(options) {
      return new _valueListModel.default(_objectSpread({
        modelName: this.modelName,
        config: this.config.valueLists
      }, options));
    }
  }]);
  return ReduxModelGenerator;
}();

exports.default = ReduxModelGenerator;
(0, _defineProperty2.default)(ReduxModelGenerator, "CustomModel", _default.default);
(0, _defineProperty2.default)(ReduxModelGenerator, "EntityModel", _entityModel.default);
(0, _defineProperty2.default)(ReduxModelGenerator, "ValueListModel", _valueListModel.default);
(0, _defineProperty2.default)(ReduxModelGenerator, "initialState", _default.default.initialState);
(0, _defineProperty2.default)(ReduxModelGenerator, "initialEntityState", _entityModel.default.initialState);
(0, _defineProperty2.default)(ReduxModelGenerator, "initialValueListState", _valueListModel.default.initialState);